import api from './base';

interface CardholderParams {
  IdNumber: string;
  companyId: string;
}

interface Cardholder {
  FirstName: string;
  LastName: string;
  IdNumber: string;
  EMail?: string;
}

class CardholderApi {
  private path = '/cardholder';

  public getList = async (params: CardholderParams): Promise<{ data: Cardholder[] }> => {
    const { data } = await api.get<{ data: Cardholder[] }>(this.path, { params });
    return data;
  };
}

export default new CardholderApi();
